import * as React from "react";
const SvgFiRrFaceTongueSweat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-tongue-sweat_svg__a)">
      <path
        fill="#062147"
        d="M24 12c0 6.617-5.383 12-12 12-3.076 0-6-1.162-8.236-3.273a1.001 1.001 0 0 1 1.373-1.455A9.96 9.96 0 0 0 12 21.999c5.514 0 10-4.486 10-10S17.514 2 12 2a9.97 9.97 0 0 0-8.91 5.455 1 1 0 0 1-1.782-.91A11.96 11.96 0 0 1 12 0c6.617 0 12 5.383 12 12m-6.274-3.039q.138.039.275.039a1 1 0 0 0 .274-1.962c-.965-.276-1.977-.941-2.46-1.62a1 1 0 0 0-1.628 1.162c.746 1.045 2.135 1.979 3.54 2.38zm-9.54-3.542c-.484.678-1.496 1.344-2.46 1.62a1 1 0 1 0 .549 1.923c1.404-.401 2.793-1.335 3.54-2.38A1 1 0 0 0 8.187 5.42zM8.5 10a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 10m7 3a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 15.5 13M5 14.5c0-1.403-1.184-3.372-1.922-4.235a.754.754 0 0 0-1.151.004C1.189 11.143 0 13.13 0 14.5a2.5 2.5 0 1 0 5 0m7-1.5c2.393 0 4.333 1.917 4.942 3.707.216.636-.288 1.292-.96 1.292h-1.017C14.797 19.509 13.702 21 11.999 21s-2.797-1.49-2.966-3H8.001c-.676 0-1.179-.662-.956-1.3.625-1.787 2.554-3.7 4.953-3.7zm1 4.6v-1.384a2.42 2.42 0 0 0-2 0V17.6c0 .662.411 1.4 1 1.4s1-.738 1-1.4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-tongue-sweat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceTongueSweat;
